import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AcceptedPaper.css';

const AcceptedPaper = () => {
    const [papers, setPapers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const papersPerPage = 10;

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/submit/accepted-papers-list`)
            .then(response => setPapers(response.data.data))
            .catch(error => setError(error.message))
            .finally(() => setLoading(false));
    }, []);

    // Pagination logic
    const indexOfLastPaper = currentPage * papersPerPage;
    const indexOfFirstPaper = indexOfLastPaper - papersPerPage;
    const currentPapers = papers.slice(indexOfFirstPaper, indexOfLastPaper);
    const totalPages = Math.ceil(papers.length / papersPerPage);

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    if (loading) return <div className="loading-state">Loading papers...</div>;
    if (error) return <div className="error-state">Error: {error}</div>;

    return (
        <div className="accepted-container">
            <div className="accepted-header">
                <h1 className="accepted-title">Accepted Papers</h1>
                <p className="accepted-subtitle">Approved Research Works</p>
            </div>

            <div className="accepted-papers-container">
                {currentPapers.length > 0 ? (
                    currentPapers.map((paper) => (
                        <div className="accepted-paper-card" key={paper._id}>
                            <div className="accepted-paper-header">
                                <span className="accepted-paper-id">Paper ID: {paper.paperID}</span>
                                <span className="accepted-paper-category">Presentation: {paper.presentationType}</span>
                            </div>
                            <h3 className="accepted-paper-title">{paper.title}</h3>
                            <div className="accepted-paper-details">
                                <p>
                                    <strong>Authors:</strong>{" "}
                                    {paper.author.map((a) => `${a.firstName} ${a.lastName}`).join(", ")}
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="no-papers">No accepted papers available</p>
                )}
            </div>

            {/* Pagination Controls */}
            <div className="pagination-controls">
                <button 
                    className="pagination-btn" 
                    onClick={handlePrev} 
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span className="pagination-info">Page {currentPage} of {totalPages}</span>
                <button 
                    className="pagination-btn" 
                    onClick={handleNext} 
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default AcceptedPaper;
